// extracted by mini-css-extract-plugin
module.exports = {"accordionDeal":"e_i2","buttonHolder":"e_j2","button":"e_k2"};